import { configureStore } from "@reduxjs/toolkit";

// user service
import profile from "./authUser/profile";
import userAuthentication from "./authUser/auth";
// user service

//api_data
//user management
import userMgt_getUsers from "./apiData/userManagement/getUsers";
import userMgt_getRoles from "./apiData/userManagement/getRoles";
import userMgt_getResources from "./apiData/userManagement/getResources";
//user management

//institution management
import institution from "./apiData/institution_management/institution";
import faculty from "./apiData/institution_management/faculty";
//institution management

// CORE_IBASS
import allInstitution from "./apiData/core_ibass/all_institution";
import allProgrammes from "./apiData/core_ibass/all_programmes";
import allFaculties from "./apiData/core_ibass/all_faculties";
//programes
import accreditedProgrammes from "./apiData/core_ibass/accredited_programmes";
import approvedprogrammes from "./apiData/core_ibass/approved_programmes";
import pendingProgrammes from "./apiData/core_ibass/pending_programmes";
import declinedprogrammess from "./apiData/core_ibass/declined_programmes";
//institutions
import pendingInstitutions from "./apiData/core_ibass/pending_institutions";
import accreditedInstitutions from "./apiData/core_ibass/accredited_institutions";
import approvedInstitutions from "./apiData/core_ibass/approved_institution";
import declinedInstitutions from "./apiData/core_ibass/declined_institutions";

//admission requirements
import admissionsRrequirments from "./apiData/core_ibass/admission_requirement";

// CORE_IBASS
//returnee application
import returneeApplications from "./apiData/returnee/returnee_application";
import approvedReturneeApplications from "./apiData/returnee/approved_applicatons";
import declinedReturneeApplications from "./apiData/returnee/declined_applications";
import pendingReturneeApplications from "./apiData/returnee/pending_applications";

//delists
import pendingDelists from "./apiData/core_ibass/pending_delists";
import approved_delists from "./apiData/core_ibass/approved_delists";
import declined_delists from "./apiData/core_ibass/declined_delists";

//Affiliations
import allAffiliations from "./apiData/core_ibass/affiliations";

//mailing
import recipientLists from "./apiData/core_ibass/mail/recipient_lists";
import outboxes from "./apiData/core_ibass/mail/outboxes";
import inboxes from "./apiData/core_ibass/mail/inboxes";
import mailThread from "./apiData/core_ibass/mail/mailTread";

//app functionality
import navMenuFunctions from "./appFunctionality/navMenuFunctions";
import snackBar from "./appFunctionality/snackbar";
import networkStatus from "./appFunctionality/networkError";
import pageProperties from "./appFunctionality/pageProperties";
//app functionality

export const ibassStore = () => {
  return configureStore({
    reducer: {
      //app functionality
      pageProperties: pageProperties,
      menuFunctions: navMenuFunctions,
      snackbar: snackBar,
      networkStatus: networkStatus,

      //mail
      recipientList: recipientLists,
      outboxes: outboxes,
      inboxes: inboxes,
      mailThreads: mailThread,
      //user
      userProfile: profile,
      userAuthentication: userAuthentication,

      //api_data
      // RETURNEE_APPLICATIONS
      returnee_applications: returneeApplications,
      approved_returnee_applications: approvedReturneeApplications,
      declined_returnee_applications: declinedReturneeApplications,
      pending_returnee_applications: pendingReturneeApplications,
      //AFFILIATIONS
      all_affiliations: allAffiliations,
      // CORE_IBASS
      all_institutions: allInstitution,
      all_programmes: allProgrammes,
      all_faculties: allFaculties,

      //delsits states
      pending_delists: pendingDelists,
      approved_delists: approved_delists,
      declined_delists: declined_delists,
      //programmes states
      accredited_programmes: accreditedProgrammes,
      pending_programmes: pendingProgrammes,
      approved_programmes: approvedprogrammes,
      declined_programmes: declinedprogrammess,
      //institutions
      accredited_institutions: accreditedInstitutions,
      approved_institutions: approvedInstitutions,
      pending_institutions: pendingInstitutions,
      declined_institutions: declinedInstitutions,

      //admission requirements
      admission_requirements: admissionsRrequirments,
      // CORE_IBASS

      //user management
      user_mgt_get_users: userMgt_getUsers,
      user_mgt_get_roles: userMgt_getRoles,
      user_mgt_get_resources: userMgt_getResources,
      //insitution management
      institution: institution,
      faculty: faculty,
    },
    middleware: (getDefaultMiddleware: any) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
  });
};

// Infer the type of makeStore
export type AppStore = ReturnType<typeof ibassStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
